import { Component, Inject, ViewChild } from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";
import {  MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Select, Store } from "@ngxs/store";
import {ServiceLevel, ChecklistTemplate, CommonService, SaveServiceLevel, Service, AppointmentTemplate, SaveAppointmentTemplate, AppointmentTemplateService,  GetDocuments, ChecklistTemplateItem, SaveChecklistTemplate, GetChecklistTemplates, CompassStateModel, GetServiceLevels, DocumentStateModel, DeleteAppointmentTemplate, GetAppointmentTemplates, ChecklistItemContent,
  ContextDocuments, BulkSubscription, Document
 } from 'huddyapi';
import { SavedProvider } from "../../settings/settings.component";
import { SelectionModel } from "@angular/cdk/collections";
import { MatTable } from "@angular/material/table";
import { Observable, Subscription, interval, takeUntil, takeWhile} from "rxjs";




@Component({
  selector: 'edit-service-levels-dialog',
  templateUrl: 'edit-service-levels-dialog.component.html',
  styleUrls: ["./edit-service-levels-dialog.component.scss"]
})
export class EditServiceLevelsDialog  {
  initialized : boolean = false;
  dirtyServiceLevel : boolean = false; 
  dirtyAppointmentTemplate : boolean = false;
  static NONE : ChecklistTemplate = {id: 0, providerId: 0, createdBy: '', name : 'None', dateCreated: 0, items: []}
  serviceLevel : ServiceLevel;
  edited : ServiceLevel;
  numberOfFamilies : number = 0;
  provider : SavedProvider;
  selectedTab : string = 'general';
  appointmentTemplates : AppointmentTemplate[] ;
  displayedColumns: string[] = ['select', 'description', 'frequency',  'services']; //'duration',//, 'checklistTemplate'
  appointmentSelection = new SelectionModel<AppointmentTemplate>(false, []); 
  checklistTemplates : ChecklistTemplate[];
  editableChecklistTemplates : ChecklistTemplate[];
  timeUnits : string[] = ['days', 'weeks', 'months', 'years'];
  editingChecklistItem : boolean = false;
  serviceLevelForm = this.formBuilder.group({
    name: ['', [Validators.required, Validators.maxLength(50)]],
    service : '',
    services:  [[], [Validators.required]],
    selectedTemplate : [],
    description : '',
    frequencyNum : [],
    frequencyUnit : [],
    durationNum : [],
    durationUnit : [],
    checklistTemplate: [],
    cltDescription: '',
    templateServices : [],
    editedChecklistTemplate : {},
    cltName: ['', [Validators.required, Validators.maxLength(50)]],
    template : '',
    cltService : {},
    item : '',
    selectedItem : {item : '', required : false, id : -1},
    instructions : [],
    itemContent : '',
    required : '',
    requiredByAppNum: 1
  });
  
  lastAddedItem : number = -10;
  @ViewChild('apptiTable', {static:false}) apptiTable: MatTable<any>;
  @Select(state => state.compassState) serviceLevelsState$: Observable<CompassStateModel>;
  @Select(state => state.documentState) documentState$;
  documentSubscription : Subscription;
  serviceLevelsSubscription : Subscription;
  retrievedServiceLevels : boolean = false;
  //checklist templates:
  editingChecklistTemplate : boolean = false;
  editedChecklistTemplate : ChecklistTemplate;
  checklistSelection = new SelectionModel<ChecklistTemplateItem>(false, []);
  checklistTemplateEdited : ChecklistTemplate;
  items : ChecklistTemplateItem[] = [];
  serviceLevels : ServiceLevel[];
  documents : Document[] = [];
  clLastAddedItem : number = -10;
  bulkSubscriptions : BulkSubscription[] = [];
  reconstructed : boolean = false;
  apptiTableRendered : boolean = false;
  contentList : ChecklistItemContent[] = [];

  constructor(
    public dialogRef: MatDialogRef<EditServiceLevelsDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder : UntypedFormBuilder,
    private common : CommonService,
    public store : Store
  )
  {
    console.log('in constructor', this.data);
    if (this.data.appointmentTemplates) {
      this.appointmentTemplates = this.data.appointmentTemplates;
    }
    this.reconstructed = true;
  }

  ngOnInit(): void {
    this.  serviceLevelsSubscription  = this.serviceLevelsState$.subscribe((compassState: CompassStateModel) => {
      console.log(compassState);
      if (compassState?.serviceLevels && !this.retrievedServiceLevels ) {
         this.serviceLevels = [].concat(compassState.serviceLevels);
         console.log('this service levels', this.serviceLevels, this.appointmentTemplates);
         if (!this.appointmentTemplates && this.serviceLevels && this.serviceLevels.length > 0) {
          const serviceLevelIds : number[] = this.serviceLevels.map(s => s.id);
          console.log('serviceLevelIds', serviceLevelIds);
          this.retrievedServiceLevels = true;
         }
      }
      if (compassState?.subscriptions) {
        this.bulkSubscriptions = compassState.subscriptions;
        this.buildContentList();
      }
      if (compassState?.appointmentTemplates && compassState?.appointmentTemplates.length > 0 && this.serviceLevel && this.serviceLevel.id) {
        console.log('entering appointments level block', compassState?.appointmentTemplates, this.serviceLevel);
        // const filtered : AppointmentTemplate[]= compassState.appointmentTemplates.filter(a => a.serviceLevelId === this.serviceLevel.id  );
        this.appointmentTemplates = this.getServiceLevelAppointmentTemplates(compassState.appointmentTemplates);

      }
      
      if (compassState?.lastSavedServiceLevel && !this.reconstructed) {
        this.data.serviceLevel = compassState.lastSavedServiceLevel;
      }
      this.reconstructed = false;
      if (compassState?.checklistTemplates) {
        //console.log('got checklist templates', compassState.checklistTemplates);
        this.checklistTemplates = [EditServiceLevelsDialog.NONE];
        for (let ct of compassState.checklistTemplates) {
          let idx : number = this.checklistTemplates.findIndex(ct2 => ct.name === ct2.name);
          if (idx === -1) {
            this.checklistTemplates.push(ct);
          }
        }
        this.checklistTemplates.reverse();
      }

      // console.log('got checklist templates2', this.checklistTemplates);
      if (this.checklistTemplates && this.appointmentTemplates && this.serviceLevels) {
        this.initialize();
      }
     
      this.provider = this.data.provider;
      // console.log('provider=', this.provider);  
      });

      this.documentSubscription =  this.documentState$.subscribe((documentState: DocumentStateModel) => {
        let filtered : ContextDocuments[] = documentState.contextDocuments.filter(cd => cd.contextType ===  'library');
        this.documents = [];
        for (let cd of filtered) {
          this.documents = [].concat(cd.documents);
        }
        this.buildContentList();
      });

  }

  getServiceLevelAppointmentTemplates(appointmentTemplates : AppointmentTemplate[]) {
    if (!this.serviceLevel) {
      return [];
    }
    return appointmentTemplates.filter(a => a.serviceLevelId === this.serviceLevel.id  );
  }

  checkServiceLevelDirty(modified : boolean = false) {
    if (modified || !this.serviceLevel ||
      (this.serviceLevel.name === this.serviceLevelForm.value.name)) {
        //console.log('setting dirty service level');
        this.dirtyServiceLevel = true;
    }
    
  }

  initializeEmptyServiceLevel() {
    this.serviceLevel =  ({
      id: undefined,
      name: '',
      services: [],
      providerId : this.data.provider.id,
    });
  }

  initialize() {
    console.log('Entering initialize', this.data);
    this.serviceLevelForm.reset();  
    this.serviceLevel = undefined;
    if (this.serviceLevels && this.data.serviceLevel && this.data.serviceLevel.id && this.data.serviceLevel.id > 0 ) {
      console.log('doing1');
      this.serviceLevel = this.serviceLevels.find(sl => sl.name === this.data.serviceLevel.name);
      this.dirtyServiceLevel = false;
    } else if (this.serviceLevelForm.value.name && this.serviceLevelForm.value.name.length > 0) {
      console.log('doing2');
      this.serviceLevel = this.serviceLevels.find(sl => sl.name === this.serviceLevelForm.value.name);
      this.dirtyServiceLevel = false;
    } else {
      console.log('doing3');
      this.initializeEmptyServiceLevel();
      this.checkServiceLevelDirty(true);
    }
    this.numberOfFamilies = this.data.numberOfFamilies;
    // console.log('numberOfFamilies', this.numberOfFamilies);
    let services : string[] = (this.serviceLevel) ? this.serviceLevel.services.map(s => s.name) : [];
   
    if (this.data.serviceLevel && this.data.serviceLevel.services && this.data.serviceLevel.services.length > 0 && this.appointmentTemplates) {
      
      for (let a of this.appointmentTemplates) {
        if (a.services && a.services.length > 0) {
          a.services = a.services.map(s => {
            const service = this.data.serviceLevel.services.find(s2 => s2.id === s.serviceId);
            if (service) {
              s.name = service.name;
            }
            return s;
          })
        }
      }

    }
    // console.log('this.appointmentTemplates', this.appointmentTemplates);
    if (this.checklistTemplates) {
      this.editableChecklistTemplates = [].concat(this.checklistTemplates.sort((t1, t2) => {
                    if (t1.name < t2.name) {
                      return -1;
                    }
                    if (t1.name > t2.name) {
                        return 1;
                    }
                    return 0;
                  }));
    }
    if (this.editableChecklistTemplates) {
      const noneIdx = this.editableChecklistTemplates.findIndex(n => n.name === EditServiceLevelsDialog.NONE.name);            
      if (noneIdx > -1) {
        this.editableChecklistTemplates.splice(noneIdx, 1);
      }
    }
    let name : string = this.serviceLevel ? this.serviceLevel.name : '';
    this.serviceLevelForm.setValue({
      name: name,
      service:  '',
      services : services,
      selectedTemplate : {id : -1, description: ''},
      description : '',
      frequencyNum : 1,
      frequencyUnit : '',
      durationNum : 1,
      durationUnit : '',
      checklistTemplate: EditServiceLevelsDialog.NONE,
      templateServices : [],
      editedChecklistTemplate : {},
      cltName:  '',
      cltDescription : '',
      template: '',
      cltService : {},
      item : '',
      selectedItem : {id : -1, item : ''},
      instructions: '',
      itemContent : [],
      required : '',
      requiredByAppNum: this.getMaxReqApptByNum()+1,

    });
    this.edited = new ServiceLevel({
      id : this.serviceLevel ? this.serviceLevel.id : undefined,
      name: name,
      services : services
    });

    this.initialized = true;
  } 

  isFormInValid() {
    return !this.dirtyServiceLevel || (this.serviceLevelForm.controls.name.invalid || 
      (!this.serviceLevelForm.value.services || this.serviceLevelForm.value.services.length === 0));
  }

  onSubmitForm() {
   if (this.dirtyAppointmentTemplate) {
    this.saveAppointmentTemplate();
   } else if (this.editingChecklistTemplate) {
    this.saveChecklistTemplate();
   } else {
    this.save();
   }
  }

  selectTab(tab : string) {
    this.selectedTab = tab;
  }


  close() {
     if (this.editingChecklistTemplate) {
        this.editChecklistTemplate( true, false);
     } else if (this.dirtyAppointmentTemplate) {
      this.dirtyAppointmentTemplate = false;
     } else {
      //need to add are you sure?
      this.dialogRef.close();
      this.cleanup();
     }
  
  }

  hasValidServiceToAdd() {
    let value : string = this.serviceLevelForm.value.service;
    return (value && value &&  value.length > 1 && 
      this.getServices().findIndex(s =>  s.name == value) == -1);
  }


  addService() {
    console.log('addService', this.hasValidServiceToAdd(), this.serviceLevel, this.serviceLevelForm.value.service);
    if (!this.serviceLevel) {
      this.initializeEmptyServiceLevel();
    }
    if (this.hasValidServiceToAdd()) {
      let services : Service[] = this.getServices();
      let value : string = this.serviceLevelForm.value.service;
      this.serviceLevel.services.push(new Service({
        name : value,
        serviceLevelId : this.serviceLevel.id
      }))
      this.serviceLevelForm.controls.services.setValue(services);
      this.serviceLevelForm.controls.service.setValue('');

      
      this.checkServiceLevelDirty(true);
    
    }
  }

  deleteService(service : Service) {
    let services : Service[] = this.getServices();
    let idx : number = services.findIndex(s => (s.id == service.id || s.name == service.name));
    console.log('delete service idx=', idx, services, service, this.serviceLevel);
    if (idx > -1) {
      services.splice(idx, 1);
      console.log(services, this.serviceLevel.services);
       this.serviceLevelForm.controls.services.setValue(services);
      console.log(this.serviceLevelForm.value.services);
      this.checkServiceLevelDirty(true);
    }
  }


  getServices(): Service[] {
    //console.log('entering get services', this.serviceLevel, this.serviceLevelForm.value.services);
    let ret : Service[] = [];
    if (this.serviceLevel) {
      ret = this.serviceLevel.services ;
    } else if (this.serviceLevelForm.value.services) {
      ret = this.serviceLevelForm.value.services;
    }
    return ret;
  }

  save() {
     
      console.log('entering save', this.serviceLevelForm.value.users);
      let g : ServiceLevel = ({
        id: (this.edited.id && this.edited.id > -1) ? this.edited.id : null,
        name : this.serviceLevelForm.value.name,
        providerId : this.provider.id,
        services : this.getServices()
       
      });
      this.store.dispatch(new SaveServiceLevel(g)).subscribe(() => {
      this.serviceLevel = this.data.serviceLevel;
      console.log('Service level saved return', this.serviceLevel);
      this.edited = g;
      this.retrievedServiceLevels = false;
      this.store.dispatch(new GetServiceLevels(this.provider.id));
      this.initialized = false;
      this.dirtyServiceLevel = false;
      this.initialize();
    });
    
  }

  cleanup() {
    this.serviceLevel = undefined;
    this.edited = undefined;
    this.retrievedServiceLevels = false;
    this.initialized = false;
    this.dirtyServiceLevel  = false;
    this.serviceLevelForm.reset();
  }

  
  saveAppointmentTemplate() {
    let appointmentTemplate : AppointmentTemplate = this.getSelectedAppointmentTemplate();
    let templateServices : AppointmentTemplateService[] = [];
    console.log('entering saveAppointmentTemplate', this.serviceLevel.services, this.serviceLevelForm.value.templateServices);
    for (let templateService of this.serviceLevelForm.value.templateServices) {
      const service : Service = this.serviceLevel.services.find(s => s.id === templateService.id);
      if (service) {
        templateServices.push({
          serviceId : service.id,
          appointmentTemplateId : appointmentTemplate ? appointmentTemplate.id : undefined
        })
      }
    }
    //console.log('built template services', this.serviceLevelForm.value.templateServices, this.serviceLevel.services, templateServices);
    let checklistTemplateId : number = undefined;
    if (this.serviceLevelForm.value.checklistTemplate) {
      if (this.serviceLevelForm.value.checklistTemplate.name != EditServiceLevelsDialog.NONE) {
        checklistTemplateId = this.serviceLevelForm.value.checklistTemplate.id;
      }
    }
    
    const updated  : AppointmentTemplate = {
      id: appointmentTemplate && appointmentTemplate.id && appointmentTemplate.id > 0 
          ? appointmentTemplate.id : undefined,
      checklistTemplateId : checklistTemplateId,
      createdBy : appointmentTemplate?.createdBy ? appointmentTemplate.createdBy :this.common.getCurrentUserToView(),
      serviceLevelId : this.serviceLevel.id,
      description : this.serviceLevelForm.value.description,
      dateCreated :  appointmentTemplate?.dateCreated ? appointmentTemplate.dateCreated : new Date().getTime(),
      frequencyAmount : this.serviceLevelForm.value.frequencyNum,
      frequencyUnit : this.serviceLevelForm.value.frequencyUnit,
      totalDuration :this.serviceLevelForm.value.durationNum,
      durationUnit :this.serviceLevelForm.value.durationUnit,
      services : templateServices,
      timezone : Intl.DateTimeFormat().resolvedOptions().timeZone
    };
    console.log('SaveAppointmentTemplate', updated, appointmentTemplate)

    this.store.dispatch(new SaveAppointmentTemplate(updated)).subscribe(t => {
         
    })
    
    this.dirtyAppointmentTemplate = false;


  }

  deleteAppointmentTemplate() {
    const appointmentTemplate : AppointmentTemplate = this.getSelectedAppointmentTemplate();
    console.log('entering delete appointment', appointmentTemplate, this.serviceLevel);
    if (appointmentTemplate.id) {
      this.store.dispatch(new DeleteAppointmentTemplate(appointmentTemplate.id, this.serviceLevel.id)).subscribe(t => 
        this.store.dispatch(new GetAppointmentTemplates([this.serviceLevel.id])).subscribe(t2 =>  this.apptiTable.renderRows() )
      );
    
    }
  }
  getSelectedAppointmentTemplate() : AppointmentTemplate {
    if (this.serviceLevelForm.value.selectedTemplate) {
      return this.serviceLevelForm.value.selectedTemplate;
    }
    return undefined;
  }



  getChecklistTemplateName(checklistTemplateId : number) : string {
    let ret : string = '';
    const checklistTemplate = this.checklistTemplates.find(ct => ct.id === checklistTemplateId);
    if (checklistTemplate) {
      ret = checklistTemplate.name;
    }
    return ret;
  }

  hasCompleteTemplate() : boolean { 
    const description : string = this.serviceLevelForm.value.description;
    const frequencyNum : number =  this.serviceLevelForm.value.frequencyNum ;
    const frequencyUnit : string = this.serviceLevelForm.value.frequencyUnit ;
    const durationNum : number =  this.serviceLevelForm.value.durationNum ;
    const durationUnit : string = this.serviceLevelForm.value.durationUnit ;
    return (description && (description.length > 0)) && (frequencyNum != undefined) 
    && (frequencyUnit && (frequencyUnit.length > 0)) && (durationNum != undefined) 
    && (durationUnit && (durationUnit.length > 0));
  }

  createNewTemplate(startEditing : boolean = false) {
    this.appointmentSelection.clear();
    this.serviceLevelForm.controls.selectedTemplate.setValue( {id : -1, description: ''});
    this.serviceLevelForm.controls.description.setValue('');
    this.serviceLevelForm.controls.frequencyNum.setValue('');
    this.serviceLevelForm.controls.frequencyUnit.setValue("");
    this.serviceLevelForm.controls.durationNum.setValue('');
    this.serviceLevelForm.controls.durationUnit.setValue("");
    this.serviceLevelForm.controls.templateServices.setValue([]);
    this.serviceLevelForm.controls.checklistTemplate.setValue(EditServiceLevelsDialog.NONE);
    this.dirtyAppointmentTemplate = true;


  }



  deleteTemplate() {
    console.log('entering delete');
    let template : AppointmentTemplate = this.serviceLevelForm.value.selectedTemplate;
    let templateIdx = this.appointmentTemplates.indexOf(template);
    console.log('templateIdx', templateIdx);
    if (templateIdx > -1)
      this.appointmentTemplates.splice(templateIdx, 1);

  }



  onTemplateSelected( ) {

      this.dirtyAppointmentTemplate = true;
      let template : AppointmentTemplate = this.serviceLevelForm.value.selectedTemplate;
      this.serviceLevelForm.controls.description.setValue(template.description);
      let checklistTemplate : ChecklistTemplate = this.checklistTemplates.find(s => s.id === template.checklistTemplateId);
      console.log('onAppointmentTemplateSelected', template);
      this.serviceLevelForm.controls.checklistTemplate.setValue(checklistTemplate);
      this.serviceLevelForm.controls.frequencyNum.setValue(template.frequencyAmount);
      this.serviceLevelForm.controls.frequencyUnit.setValue(template.frequencyUnit);
      this.serviceLevelForm.controls.durationNum.setValue(template.totalDuration);
      this.serviceLevelForm.controls.durationUnit.setValue(template.durationUnit);
      this.serviceLevelForm.controls.templateServices.setValue(this.getTemplateServicesList(template.services));
     
    console.log('onTemplateSelected', this.serviceLevelForm.value, this.getServices());
  }

  getTemplateServicesList(services : AppointmentTemplateService[]) : Service[] {
    let ret : Service[] = [];
    if (services) {
      const serviceIds : number[]= services.map(s => s.serviceId);
      ret = this.getServices().filter(s => serviceIds.indexOf(s.id) > -1);
    }
    return ret;
  }

  //checklist template:

  getMaxReqApptByNum() : number {
    return Math.max.apply(null,
      this.items.map(function (o) { return o.requiredByAppNum; }));
  }

  hasCompleteItem() : boolean {
    if (!this.editingChecklistItem) {
      return false;
    }
    const item : string = this.serviceLevelForm.value.item;
    const required : boolean =  this.serviceLevelForm.value.required ;
    const service : string = this.serviceLevelForm.value.cltService ;
    const requiredByAppNum : number = this.serviceLevelForm.value.requiredByAppNum;
    return (item && (item.length > 0) && (required != undefined) && (service != undefined) && (!required || (required && requiredByAppNum && requiredByAppNum > 0)));
  }

  editChecklistTemplate(reset : boolean = false, isNew : boolean = false) {
    let clt : ChecklistTemplate = this.serviceLevelForm.value.editedChecklistTemplate;
    console.log('entering editChecklistTemplate', clt, reset, this.selectedTab);
    if (reset) {
      this.editingChecklistTemplate = false;
      this.editingChecklistItem = false;
      return;
    }
    this.editingChecklistTemplate = true;
    const name : string = clt && clt.name ? clt.name : '';
    const id : number = clt && clt.id ? clt.id : -1;
    const createdBy : string = clt && clt.createdBy ? clt.createdBy : undefined;
    const dateCreated : number = clt && clt.dateCreated ? clt.dateCreated : new Date().getTime();
    this.editedChecklistTemplate = {
      name: name,
      description : clt.description,
      providerId : this.provider.id,
      items : this.items,
      id : id,
      createdBy : createdBy,
      dateCreated : dateCreated
    };
    this.items = (clt && clt.items) ? [].concat(clt.items) : [];
    console.log('items:', this.items);
    this.sortItemsByReqApptByNum();
    this.serviceLevelForm.controls.editedChecklistTemplate.setValue(undefined);
    this.serviceLevelForm.controls.cltName.setValue(name);
    this.serviceLevelForm.controls.cltDescription.setValue(clt.description);
    this.serviceLevelForm.controls.selectedItem.setValue( {id : -1, item : ''});
    this.serviceLevelForm.controls.item.setValue('');
    this.serviceLevelForm.controls.instructions.setValue('');
    this.serviceLevelForm.controls.itemContent.setValue([]);
    this.serviceLevelForm.controls.cltService.setValue( {});
    this.serviceLevelForm.controls.required.setValue('');
    this.serviceLevelForm.controls.requiredByAppNum.setValue(this.getMaxReqApptByNum()+1);
    this.serviceLevelForm.controls.item.disable();
    this.serviceLevelForm.controls.cltService.disable();
    this.serviceLevelForm.controls.required.disable();
    this.serviceLevelForm.controls.itemContent.disable();
    this.serviceLevelForm.controls.instructions.disable();
    this.serviceLevelForm.controls.requiredByAppNum.disable();
    this.checklistSelection.clear();
  

  }

  sortItemsByReqApptByNum() {
    this.items.sort((a, b) => {
      if (!a.requiredByAppNum && b.requiredByAppNum) {
        return 1;
      }
      if (a.requiredByAppNum && !b.requiredByAppNum) {
        return -1;
      }
      if (a.requiredByAppNum < b.requiredByAppNum) {
          return -1;
      }
      if (a.requiredByAppNum > b.requiredByAppNum) {
          return 1;
      }
      return 0;
  });
  }
  isCLTFormInValid() {
    return this.editingChecklistTemplate && 
    ((!this.serviceLevelForm.value.cltName) 
    ||  (!this.items || this.items.length === 0));
  }


  deleteItem() {
    const selectedItem = this.serviceLevelForm.value.selectedItem;
    console.log('entering deleteItem', this.serviceLevelForm.value.selectedItem);
    if (!selectedItem)
      return;

    const idx : number = this.items.findIndex(item => item.id === selectedItem.id);

    if (idx > -1) {
      this.items.splice(idx, 1);
    }
    this.createNewItem();
    this.editingChecklistItem = false;
  }


  // getServices(): Service[] {
  //   return this.checklistTemplateForm.value.services;
  // }
  getItems(): ChecklistTemplateItem[] {
    return this.editedChecklistTemplate.items;
  }



  saveChecklistTemplate() {

      console.log('entering save', this.items);
      let g : ChecklistTemplate = ({
        id: (this.editedChecklistTemplate.id && this.editedChecklistTemplate.id > -1) ? this.editedChecklistTemplate.id : null,
        name : this.serviceLevelForm.value.cltName,
        description: this.serviceLevelForm.value.cltDescription,
        providerId : this.provider.id,
        createdBy:  (this.editedChecklistTemplate.id && this.editedChecklistTemplate.id > -1) ? this.editedChecklistTemplate.createdBy : this.common.getCurrentUserToView(),
        dateCreated : (this.editedChecklistTemplate.id && this.editedChecklistTemplate.id > -1) ? this.editedChecklistTemplate.dateCreated : new Date().getTime(),
        items : this.items.map(item =>({
            id : item?.id > 0 ? item.id : undefined,
            checklistTemplateId: this.editedChecklistTemplate.id,
            serviceId : item.serviceId,
            item: item.item,
            instructions : item.instructions,
            content : item.content,
            required: item.required,
            requiredByAppNum: item.requiredByAppNum
        }))
      });
    console.log('Checklist template to save', g);  
    this.store.dispatch(new SaveChecklistTemplate(g)).subscribe(t => {
      this.store.dispatch(new GetChecklistTemplates(this.provider.id));
        });
 
    this.editingChecklistTemplate = false;
    this.editingChecklistItem = false;
    this.serviceLevelForm.controls.editedChecklistTemplate.setValue(undefined);
  }


  onItemSelected() {

      const item :  ChecklistTemplateItem = this.serviceLevelForm.value.selectedItem;
     this.serviceLevelForm.controls.item.setValue(item.item);
      let service : Service = undefined
      if (item.serviceId && item.serviceId > 0) {
        service = this.serviceLevel.services.find(s => s.id === item.serviceId);
        console.log('service', service, item.serviceId, this.getServices(), this.serviceLevel.services);
      }
      
      this.serviceLevelForm.controls.cltService.setValue(service);
      this.serviceLevelForm.controls.required.setValue(item.required);
      this.serviceLevelForm.controls.requiredByAppNum.setValue(item.requiredByAppNum);
      this.serviceLevelForm.controls.instructions.setValue(item.instructions);
      this.serviceLevelForm.controls.itemContent.setValue(item.content.map(ci => ci.contentIdentifier));
      this.serviceLevelForm.controls.item.enable();
      this.serviceLevelForm.controls.cltService.enable();
      this.serviceLevelForm.controls.required.enable();
      this.serviceLevelForm.controls.instructions.enable();
      this.serviceLevelForm.controls.itemContent.enable();
      this.serviceLevelForm.controls.requiredByAppNum.enable();
     this.editingChecklistItem = true;

     console.log('onItemSelected', this.serviceLevelForm.getRawValue());
    
  } 

  cancelItem() {
    this.checklistSelection.clear();
    this.editingChecklistItem = false;
    this.serviceLevelForm.controls.selectedItem.setValue(null);
  }


  createNewItem() {
    this.checklistSelection.clear();
    this.serviceLevelForm.controls.selectedItem.setValue({id : -1, item: ''});
    this.serviceLevelForm.controls.item.setValue('');
    this.serviceLevelForm.controls.required.setValue(false);
    this.serviceLevelForm.controls.cltService.setValue(undefined);
    this.serviceLevelForm.controls.instructions.setValue(undefined);
    this.serviceLevelForm.controls.itemContent.setValue([]);
    this.serviceLevelForm.controls.requiredByAppNum.setValue(this.getMaxReqApptByNum()+1);
    this.serviceLevelForm.controls.item.enable();
    this.serviceLevelForm.controls.cltService.enable();
    this.serviceLevelForm.controls.required.enable();
    this.serviceLevelForm.controls.instructions.enable();
    this.serviceLevelForm.controls.itemContent.enable();
    this.serviceLevelForm.controls.requiredByAppNum.enable();
    this.editingChecklistItem = true; 
  }



  saveItem() {
    console.log('entering saveItem', this.serviceLevelForm.getRawValue());
    let item : ChecklistTemplateItem = this.serviceLevelForm.value.selectedItem;
    console.log('selected', item);
    item.item = this.serviceLevelForm.value.item;
    item.required = this.serviceLevelForm.value.required;
    item.requiredByAppNum = this.serviceLevelForm.value.requiredByAppNum;
    item.instructions = this.serviceLevelForm.value.instructions;
    let contentIdentifiers : string[] = this.serviceLevelForm.value.itemContent;
    let content : ChecklistItemContent[] = this.contentList
      .filter(content => contentIdentifiers.indexOf(content.contentIdentifier) > -1);
    let editedContent : ChecklistItemContent[] = [];  
    console.log('finding content on this item', item);
    for (let c of content) {
      let edited : ChecklistItemContent | undefined = undefined;
      if (item.content) {
          edited = item.content.find(c3 => c3.contentIdentifier == c.contentIdentifier);
      }
      if (edited) {
        editedContent.push(edited);
      } else {
          editedContent.push({contentType : c.contentType,
          contentName : c.contentName,
          contentIdentifier: c.contentIdentifier,
          checklistTemplateItemId : item.id 
        });
      }
    }  
    item.content = [].concat(editedContent);
    item.serviceId = this.serviceLevelForm.value.cltService.id;
    item.serviceName = this.serviceLevelForm.value.cltService.name;
    if (item.id === -1) {
      item.id = this.lastAddedItem--;
      this.items.push(item);
      console.log('added item', item, this.items);
    }
    this.sortItemsByReqApptByNum(); 
    this.editingChecklistItem = false;
    console.log('leaving saveItem', item);
  }
  getServiceName( item : ChecklistTemplateItem) {
    const service : Service = this.serviceLevel.services.find(s => s.id === item.serviceId);
    return service ? service.name  : item.serviceName;
  }

  buildContentList() {
    this.contentList = [];
    if (this.bulkSubscriptions) {
     for (let b of this.bulkSubscriptions) {
      this.contentList.push({
          contentType: 'Compass',
          contentIdentifier : b.compass.stateMachineName,
          contentName : b.compass.name
      });
     }
    }
    if (this.documents) {
      for (let d of this.documents) {
        this.contentList.push({
          contentType: 'Document',
          contentIdentifier : d.url,
          contentName : d.name
      });
      }
    }
    console.log('content', this.contentList);
  }

}

